import _ from 'lodash';
import {
  join, select, fork, put, call,
} from 'redux-saga/effects';
import nsToken from '@netsapiens/netsapiens-js/dist/token';

import * as actions from '../state';
import fetchBoard from './services/board/fetchBoard';
import fetchCharts from './services/chart/fetchCharts';
import { setTitle } from './setTitle';
import { userUiConfigs } from './userUiConfigs';
// eslint-disable-next-line import/no-cycle
import { nsSocketConnect } from './nsSocketConnect';
// eslint-disable-next-line import/no-cycle
import nsSocketConnected from './services/nsSocketConnected';

let _boardTask;
let _chartsTask;

export default function* changeBoard(event) {
  const { boardId } = event.payload;

  if (!boardId) {
    const appURL = yield select((state) => actions.selectConfig(state, 'appURL'));
    window.history.pushState({ urlPath: appURL }, '', appURL);

    yield put(actions.setBoard({}));
    yield put(actions.setCharts([]));
    yield put(actions.isLoading(false));
  } else {
    const isPublic = event.payload.isPublic || false; // if not set, default to false

    let authToken;

    try {
      // clear state
      yield put(actions.setBoard(null));
      yield put(actions.setCharts([]));

      // this seems to only work if placed after setBoard/setCharts, no idea why
      yield put(actions.isLoading(true));

      // push board route to history (eg: set the URL)
      const appURL = yield select((state) => actions.selectConfig(state, 'appURL'));
      const newPath = isPublic
        ? `${appURL}p/${boardId}`
        : appURL + boardId;
      window.history.pushState({ urlPath: newPath }, '', newPath);

      // fetch data
      if (isPublic) {
        _boardTask = yield fork(fetchBoard, {
          publicId: boardId,
        });

        _chartsTask = yield fork(fetchCharts, {
          publicId: boardId,
        });
      } else {
        authToken = nsToken.getDecoded();

        _boardTask = yield fork(fetchBoard, {
          ...authToken,
          userId: authToken.user,
          boardId,
        });

        _chartsTask = yield fork(fetchCharts, {
          ...authToken,
          userId: authToken.user,
          boardId,
        });
      }

      yield join(_boardTask);

      // set data
      const board = _boardTask.result();
      yield put(actions.setBoard(board));

      if (board.name) { yield fork(setTitle, board.name); }

      if (isPublic) {
        // fetch and set UI configs specific to this board's domain
        yield call(userUiConfigs, { domain: board.domain });

        yield fork(nsSocketConnect);
        yield call(nsSocketConnected);
      }

      yield put(actions.viewOnly(false)); // default viewOnly to false, but following logic may flip it

      if (!isPublic && String(board.owner_id) !== String(authToken.user)) { // if this is a shared board
        let isEditable = false;

        if (board.share_details.edit_enabled) {
          isEditable = board.share_details.edit_enabled;
        } else {
          let shareDetails = board.share_details;
          if (_.isPlainObject(shareDetails)) {
            shareDetails = Object.entries(board.share_details);
          }

          shareDetails.forEach((shareRule) => {
            switch (shareRule.type) {
              case 'subscriber':
                if (String(shareRule.value) === String(authToken.sub) && shareRule.allow_edit) { isEditable = true; }
                break;
              default:
            }
          });
        }

        yield put(actions.viewOnly(!isEditable)); // viewOnly = !isEditable
      }

      yield join(_chartsTask);

      const charts = yield _chartsTask.result();
      yield put(actions.setCharts(charts.length ? charts : []));
    } catch (error) {
      console.error(error);
    }

    yield put(actions.isLoading(false));
  }
}
